<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="80%"  persistent>
      <v-card :loading="!is_fetched_nomenclature_remains">
        <v-card-actions>
          <h3 class="pl-2">
            <span v-if="nomenclature_remains">
              {{ nomenclature_remains.brand }}
              {{ nomenclature_remains.part_code }}
              {{ nomenclature_remains.name }}
            </span>
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn
              elevation="0"
              :title="$t('applicabilityWindow.applicability')"
              @click="
                  applicabilityWin.partNumber = nomenclature_remains && nomenclature_remains.part_code;
                  applicabilityWin.isVisible = true;
                "
          >
            <v-icon x-small>$applicability</v-icon>{{ $t('applicabilityWindow.applicability') }}
          </v-btn>
            <applicability-window
                :part-number="applicabilityWin.partNumber"
                :show="applicabilityWin.isVisible"
                @hide="applicabilityWin.isVisible = false"
            ></applicability-window>
          </div>
          <v-data-table
            ref="goodsIncomingTable"
            :headers="nomenclatureGoodsMovementsTableHeader"
            :items="
              (nomenclature_remains && nomenclature_remains.goods_movements) ||
              []
            "
            class="elevation-0 w-100"
            :loading="!is_fetched_nomenclature_remains"
            :disabled="!is_fetched_nomenclature_remains"
            :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          50, 100,
          //-1
        ],
      }"
          >
            <template v-slot:footer.page-text="props">
              {{
                $t("tables.x_of_y", [
                  `${props.pageStart}-${props.pageStop}`,
                  props.itemsLength,
                ])
              }}
            </template>
            <template v-slot:item.price_with_margin="props">
              {{ formatCurrency(props.item.price_with_margin) }}
            </template>
            <template v-slot:item.price="props">
              {{ formatCurrency(props.item.price) }}
            </template>
            <template v-slot:item.amount="props">
              <span v-if="parseInt(props.item.operation) === -1">-</span>{{ props.item.amount }}
            </template>
            <template v-slot:item.basis="props">
              <span class="text-no-wrap">
                <span v-if="parseInt(props.item.operation) === 1">
                  {{ $t("goods.type_incoming") }}
                </span>
                <span v-if="parseInt(props.item.operation) === -1">
                  {{ $t("goods.type_writeoff") }}
                </span>
                <span
                  v-if="
                    props.item.goods_movement_basis &&
                    props.item.goods_movement_basis.goods_movement_document_type
                  "
                >
                  № {{ props.item.goods_movement_basis.human_number }}
                  {{ props.item.goods_movement_basis.date }} [{{
                    $t(
                      "movementDocumentTypes.full." +
                        props.item.goods_movement_basis
                          .goods_movement_document_type.name
                    )
                  }}]
                </span>
                <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  color="primary"
                  class="mb-0 ml-3 px-0 white--text"
                  x-small
                  @click="showGoodsMovementForm(props.item.goods_movement_basis)"
                >
                  <v-icon x-small>fa-info-circle</v-icon>
                </v-btn>
              </span>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider class=""></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="red" class="white--text" @click="close">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <goods-movement-form
        :id="goodsMovementForm.id"
        :show="goodsMovementForm.isVisible"
        @hide="
        goodsMovementForm.isVisible = false;
        goodsMovementForm.id = null;
        goodsMovementForm.type = null;
      "
        :type="goodsMovementForm.type"
    />

  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import GoodsMovementForm from "@/components/storage/GoodsMovementForm";
import ApplicabilityWindow from "../common/ApplicabilityWindow";
import CommonMixin from "@/mixins/common";

export default {
  name: "RemainsInfoForm",
  components: {ApplicabilityWindow, GoodsMovementForm},
  mixins: [CommonMixin],
  props: {
    id: null,
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    applicabilityWin: {
      partNumber: null,
      isVisible: false,
    },
    goodsMovementForm: {
      isVisible: false,
      id: null,
      type: null
    },
  }),
  methods: {
    close() {
      this.showWindow = false;
    },
    showGoodsMovementForm(item){
      this.goodsMovementForm.isVisible = true;
      this.goodsMovementForm.id = item.id;
      this.goodsMovementForm.type = item.goods_movement_document_type.type;
    },
  },
  computed: {
    nomenclatureGoodsMovementsTableHeader() {
      return [
        {
          text: this.$t("common.amount"),
          value: "amount",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price"),
          value: "price",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price_with_margin"),
          value: "price_with_margin",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("goods.counterparty"),
          value: "goods_movement_basis.supplier.name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("goods.basis"),
          value: "basis",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage"),
          value: "storage.name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack"),
          value: "rack.name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack_shelve"),
          value: "shelf.name",
          sortable: false,
          class: "text-no-wrap",
        },
      ];
    },
    isDisabledForm() {
      return (
        this.savingInProgress ||
        (this.nowProcessingItemWithId === this.id &&
          this.nowProcessingItemWithId !== null)
      );
    },
    ...mapFields("goods_remains", [
      "is_fetched_nomenclature_remains",
      "nomenclature_remains",
    ]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  watch: {
    show(to) {
      if (to) {
        this.$store.dispatch("goods_remains/getNomenclatureRemains", {
          id: this.id,
        });
      }
    },
  },
};
</script>

<style scoped></style>
